module.exports = __webpack_public_path__ + "img/business_risk_02.36a49be1.png";